import React, { useState } from "react";
import { Typography, Link as MuiLink, IconButton, Tooltip } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

 
const BusinessAddressLink = ({ address }) => {
  const [copyTooltip, setCopyTooltip] = useState("Copy Address");

  // Construct a Google Maps Directions URL with destination set to the address.
  // Omitting origin lets Google use the user's current location.
  const googleDirectionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;

  const handleCopy = async (e) => {
    // Prevent the click event from propagating so that it doesn't trigger the link
    e.preventDefault();
    e.stopPropagation();

    try {
      await navigator.clipboard.writeText(address);
      setCopyTooltip("Copied!");
      setTimeout(() => setCopyTooltip("Copy Address"), 2000);
    } catch (error) {
      console.error("Failed to copy address", error);
    }
  };

  return (
    <MuiLink
      href={googleDirectionsUrl}
      target="_blank"
      rel="noopener noreferrer"
      underline="none"
      sx={{ display: "flex", alignItems: "center" }}
    >
      <LocationOnIcon fontSize="small" sx={{ mr: 0.5 }} />
      <Typography variant="body2" color="textSecondary">
        {address}
      </Typography>
      <Tooltip title={copyTooltip}>
        <IconButton
          size="small"
          onClick={handleCopy}
          sx={{ ml: 1 }}
        >
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </MuiLink>
  );
};

export default BusinessAddressLink;
